module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--2--redeem-f31b3d6d.png";